import { useContext } from 'react';

import Text from 'components/common/Text';
import Edit from 'components/icons/illustrative/Edit';
import Repeat from 'components/icons/illustrative/Repeat';
import { BasketContext, UserContext } from 'components/signUpFunnel/Contexts';
import { basketCutoffLocalTimeNoZone, thankYouBasketCutoffDate } from 'helpers/timeFormat';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const ThankYouSubscriptionStatus = () => {
  const { basket } = useContext(BasketContext);
  const { user } = useContext(UserContext);
  const { weeklyMeals } = user;
  const { isUnderBp1 } = useScreenSizeConstants();

  return (
    <aside
      className="col-span-1 flex w-full flex-col gap-6 py-6 bp2:gap-8"
      aria-label="Subscription details"
    >
      <div className="flex gap-[8px] bp2:flex-col bp2:gap-[2px]">
        <Edit svgSize={isUnderBp1 ? ICON_SIZES.MD : ICON_SIZES.LG} />
        <div className="flex flex-col gap-1">
          <Text brandStylesOverrides="textMd bp1:h6 bp1:text-secondary">
            Edit by {thankYouBasketCutoffDate(basket?.editingCutoff)} at{' '}
            {basketCutoffLocalTimeNoZone(basket?.editingCutoff)}
          </Text>
          <Text brandStylesOverrides="textSm bp1:text text-charcoal-90">
            Order confirmed and your card is charged.
          </Text>
        </div>
      </div>
      <div className="flex gap-[8px] bp2:flex-col bp2:gap-[2px]">
        <Repeat svgSize={isUnderBp1 ? ICON_SIZES.MD : ICON_SIZES.LG} />
        <div className="flex flex-col gap-1">
          <Text brandStylesOverrides="textMd bp1:h6 bp1:text-secondary">
            {`You'll enjoy ${weeklyMeals} meals per week`}
          </Text>
          <Text brandStylesOverrides="textSm bp1:text text-charcoal-90">
            Skip or cancel anytime.
          </Text>
        </div>
      </div>
    </aside>
  );
};

export default ThankYouSubscriptionStatus;
